import type { GameNetBridge } from '../game/contract';
import type { NetPort } from './types';

/**
 * The game engine's view of the network for one race. Race events are tagged with the
 * race id so that, after a reconnect, events of a race that has meanwhile ended are dropped
 * instead of being applied to the next race.
 */
export function createGameNetBridge(net: NetPort, raceId: string): GameNetBridge {
  return {
    serverNow: () => net.serverNow(),
    // Lossy: a backed-up connection gets no stale positions in front of the race events.
    sendState: (state) => {
      net.send({ t: 'race.state', s: state }, { lossy: true });
    },
    sendEvent: (event) => net.sendReliable({ t: 'race.event', e: event }, raceId),
    onStates: (listener) => net.on('race.states', (message) => listener(message.players)),
    onEvent: (listener) => net.on('race.event', (message) => listener(message.from, message.e)),
  };
}
